<template>
  <PageLayout>
    <template #main>
      <h2 class="text-h3 font-weight-bold navy--text text--darken-1 pb-4">
        Zadejte nové heslo
      </h2>

      <v-alert type="info" class="mb-8" outlined icon="mdi-information-outline">
        Ujistěte se, že Vaše nové heslo je dostatečně silné, nezadávejte krátká
        a slabá hesla.
      </v-alert>

      <form autocomplete="off" class="pb-10">
        <v-text-field
          v-model="password"
          label="Nové heslo"
          :type="showPassword ? 'text' : 'password'"
          outlined
          name="user-password"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPassword = !showPassword"
        ></v-text-field>

        <v-text-field
          v-model="passwordRetype"
          label="Nové heslo ještě jednou"
          :type="showPasswordRetype ? 'text' : 'password'"
          outlined
          name="user-password"
          :append-icon="showPasswordRetype ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPasswordRetype = !showPasswordRetype"
        ></v-text-field>

        <v-alert
          v-if="apiResponseState.status === 200"
          type="success"
          outlined
          text
          class="mb-4"
        >
          <div>
            Vaše nové heslo bylo nastaveno, můžete se
            <router-link to="login" class="link link-underline navy--text">
              přihlásit </router-link
            >.
          </div>
        </v-alert>

        <v-alert
          v-if="apiResponseState.status > 200"
          type="error"
          outlined
          text
          class="mb-4"
        >
          <div v-if="apiResponseState.status === 400">
            Ověřovací token je neplatný, požádajte znovu o
            <router-link
              to="reset-password"
              class="link link-underline navy--text"
            >
              reset hesla </router-link
            >.
          </div>
          <div v-else-if="apiResponseState.status === 404">
            Ověřovací token nebyl nalezen, požádajte znovu o
            <router-link
              to="reset-password"
              class="link link-underline navy--text"
            >
              reset hesla </router-link
            >.
          </div>
          <div v-else>
            Něco se pokazilo
          </div>
        </v-alert>
      </form>

      <div class="text-center pb-10">
        <v-btn
          color="primary"
          class="c-btn"
          :disabled="disabledBtn"
          @click="onSetClick"
        >
          Vytvořit nové heslo
        </v-btn>
      </div>

      <div class="text-center pb-8">
        <router-link to="login" class="link link-underline navy--text">
          Zpět k přihlášení
        </router-link>
      </div>
    </template>
  </PageLayout>
</template>

<script>
import { call, get } from "vuex-pathify"

import PageLayout from "@/components/page/auth/PageLayout.vue"

export default {
  name: "SetPassword",
  components: {
    PageLayout,
  },
  data() {
    return {
      valid: false,
      password: "",
      passwordRetype: "",
      showPassword: false,
      showPasswordRetype: false,
      token: null,
    }
  },
  computed: {
    ...get("app", ["apiResponseState"]),
    disabledBtn() {
      return !(
        this.password.length > 2 && this.password === this.passwordRetype
      )
    },
  },
  methods: {
    ...call("app", ["resetApiResponseState"]),
    ...call("auth", ["setPassword"]),

    onSetClick() {
      this.setPassword({
        password: this.password,
        token: this.token,
      })
    },
  },
  mounted() {
    this.resetApiResponseState()

    this.token = this.$router.currentRoute.query.token
  },
}
</script>
